import { Text } from '@chakra-ui/react';

import { Tooltip } from '@nocowanie/common-ui/components/molecules/tooltip';

export const AvantioLabel = ({
    labelKey,
    tooltipKey,
}: {
    labelKey: string;
    tooltipKey: string;
}) => (
    <>
        {labelKey}
        <Tooltip positioning={{ placement: 'top' }} buttonProps={{ verticalAlign: 'middle' }}>
            <Text
                dangerouslySetInnerHTML={{
                    __html: tooltipKey,
                }}
            />
        </Tooltip>
    </>
);
